import React, { useEffect, useState } from "react";
import TextInput from "./CustomInputs/TextInput"
import Swal from "sweetalert2/dist/sweetalert2.all"

function DriverForm(props) {

    const [name, setName] = useState("")
    const [mail, setMail] = useState("")
    const [phone, setPhone] = useState("")

    const handleSubmit = (e) => {
        e.preventDefault();
        let data = {name: name, email: mail, phone: phone}
        api.createDriver(data).then(res =>{
            Swal.fire("Başarılı", "Sürücü kaydı tamamlandı", "success")

        }).catch(err => {
            Swal.fire("Başarısız", "", "error")
        })
    }
    const handleName = (val) => {
        setName(val);
    }
    const handleMail = (val) => {
        setMail(val)
    }
    const handlePhone = (val) => {
        setPhone(val)
    }


    return (
        <div className="col-12 mt-4">
            <form onSubmit={handleSubmit}>
                <TextInput type="text" name="driver" label="Sürücü Adı" passValue={handleName}/>
                <TextInput type="mail" name="mail" label="Email" passValue={handleMail}/>
                <TextInput type="text" name="phone" label="Telefon Numarası" placeholder="0212 255 25 25" passValue={handlePhone}/>
                <button type="submit" className="btn btn-primary float-right w-25">Onayla</button>
            </form>
        </div>
    )
}

export default DriverForm
